const defaultState = {
  thinkificUserId: null,
  isLoadingProduct: false,
  product: null,
  isValidatingCode: false,
  discountCode: null,
  isSubmittingOrder: false,
  isCreatePaymentUrl: false,
  productByTxnLoading: false,
  productOrder: null,
};

export const TYPES = {
  SET_THINKIFIC_USER_ID: 'SET_THINKIFIC_USER_ID',
  FETCH_PRODUCT: 'FETCH_PRODUCT',
  FETCH_PRODUCT_SUCCESS: 'FETCH_PRODUCT_SUCCESS',
  FETCH_PRODUCT_FAILED: 'FETCH_PRODUCT_FAILED',

  VALIDATE_DISCOUNT_CODE: 'VALIDATE_DISCOUNT_CODE',
  VALIDATE_DISCOUNT_CODE_SUCCESS: 'VALIDATE_DISCOUNT_CODE_SUCCESS',
  VALIDATE_DISCOUNT_CODE_FAILED: 'VALIDATE_DISCOUNT_CODE_FAILED',

  SUBMIT_ORDER: 'SUBMIT_ORDER',
  SUBMIT_ORDER_SUCCESS: 'SUBMIT_ORDER_SUCCESS',
  SUBMIT_ORDER_FAILED: 'SUBMIT_ORDER_FAILED',

  REJECT_ORDER: 'REJECT_ORDER',
  REJECT_ORDER_SUCCESS: 'REJECT_ORDER_SUCCESS',
  REJECT_ORDER_FAILED: 'REJECT_ORDER_FAILED',

  CREATE_PAYMENT_URL: 'CREATE_PAYMENT_URL',
  CREATE_PAYMENT_URL_SUCCESS: 'CREATE_PAYMENT_URL_SUCCESS',
  CREATE_PAYMENT_URL_FAILED: 'CREATE_PAYMENT_URL_FAILED',

  GET_PRODUCT_BY_TRANSACTION: 'GET_PRODUCT_BY_TRANSACTION',
  GET_PRODUCT_BY_TRANSACTION_SUCCESS: 'GET_PRODUCT_BY_TRANSACTION_SUCCESS',
  GET_PRODUCT_BY_TRANSACTION_FAILED: 'GET_PRODUCT_BY_TRANSACTION_FAILED',

  CHECK_TRANSACTION_VNPAY: 'CHECK_TRANSACTION_VNPAY',
  CHECK_TRANSACTION_VNPAY_SUCCESS: 'CHECK_TRANSACTION_VNPAY_SUCCESS',
  CHECK_TRANSACTION_VNPAY_FAILED: 'CHECK_TRANSACTION_VNPAY_FAILED',

  GET_PRODUCT_BY_PAYPAL_TRANSACTION: 'GET_PRODUCT_BY_PAYPAL_TRANSACTION',
  GET_PRODUCT_BY_PAYPAL_TRANSACTION_SUCCESS: 'GET_PRODUCT_BY_PAYPAL_TRANSACTION_SUCCESS',
  GET_PRODUCT_BY_PAYPAL_TRANSACTION_FAILED: 'GET_PRODUCT_BY_PAYPAL_TRANSACTION_FAILED',

  CHECK_TRANSACTION_PAYPAL: 'CHECK_TRANSACTION_PAYPAL',
  CHECK_TRANSACTION_PAYPAL_SUCCESS: 'CHECK_TRANSACTION_PAYPAL_SUCCESS',
  CHECK_TRANSACTION_PAYPAL_FAILED: 'CHECK_TRANSACTION_PAYPAL_FAILED',

  CREATE_KAT_PAYMENT: 'CREATE_KAT_PAYMENT',
  CREATE_KAT_PAYMENT_SUCCESS: 'CREATE_KAT_PAYMENT_SUCCESS',
  CREATE_KAT_PAYMENT_FAILED: 'CREATE_KAT_PAYMENT_FAILED',

  SUBMIT_KAT_IPN: 'SUBMIT_KAT_IPN',
  SUBMIT_KAT_IPN_SUCCESS: 'SUBMIT_KAT_IPN_SUCCESS',
  SUBMIT_KAT_IPN_FAILED: 'SUBMIT_KAT_IPN_FAILED',

  CREATE_KYTE_PAYMENT: 'CREATE_KYTE_PAYMENT',
  CREATE_KYTE_PAYMENT_SUCCESS: 'CREATE_KYTE_PAYMENT_SUCCESS',
  CREATE_KYTE_PAYMENT_FAILED: 'CREATE_KYTE_PAYMENT_FAILED',

  SUBMIT_KYTE_IPN: 'SUBMIT_KYTE_IPN',
  SUBMIT_KYTE_IPN_SUCCESS: 'SUBMIT_KYTE_IPN_SUCCESS',
  SUBMIT_KYTE_IPN_FAILED: 'SUBMIT_KYTE_IPN_FAILED',

  HANDLE_KWALLET_PURCHASE: 'HANDLE_KWALLET_PURCHASE',
  HANDLE_KWALLET_PURCHASE_SUCCESS: 'HANDLE_KWALLET_PURCHASE_SUCCESS',
  HANDLE_KWALLET_PURCHASE_FAILED: 'HANDLE_KWALLET_PURCHASE_FAILED',
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case TYPES.SET_THINKIFIC_USER_ID:
      return { ...state, thinkificUserId: action.data };
    case TYPES.FETCH_PRODUCT:
      return { ...state, isLoadingProduct: true };
    case TYPES.FETCH_PRODUCT_FAILED:
      return { ...state, isLoadingProduct: false };
    case TYPES.FETCH_PRODUCT_SUCCESS:
      return { ...state, isLoadingProduct: false, product: action.data };

    case TYPES.GET_PRODUCT_BY_TRANSACTION:
      return { ...state, productByTxnLoading: true };
    case TYPES.GET_PRODUCT_BY_TRANSACTION_FAILED:
      return { ...state, productByTxnLoading: false };
    case TYPES.GET_PRODUCT_BY_TRANSACTION_SUCCESS:
    case TYPES.GET_PRODUCT_BY_PAYPAL_TRANSACTION_SUCCESS:
      return {
        ...state,
        productByTxnLoading: false,
        ...action.data,
      };

    case TYPES.VALIDATE_DISCOUNT_CODE:
      return { ...state, isValidatingCode: true };
    case TYPES.VALIDATE_DISCOUNT_CODE_FAILED:
      return { ...state, isValidatingCode: false };
    case TYPES.VALIDATE_DISCOUNT_CODE_SUCCESS:
      return { ...state, isValidatingCode: false, discountCode: action.data };

    case TYPES.SUBMIT_ORDER:
      return { ...state, isSubmittingOrder: true };
    case TYPES.SUBMIT_ORDER_FAILED:
    case TYPES.SUBMIT_ORDER_SUCCESS:
      return { ...state, isSubmittingOrder: false, productOrder: action.data };

    case TYPES.REJECT_ORDER:
      return { ...state, isSubmittingOrder: true };
    case TYPES.REJECT_ORDER_FAILED:
    case TYPES.REJECT_ORDER_SUCCESS:
      return { ...state, isSubmittingOrder: false };

    case TYPES.CREATE_PAYMENT_URL:
      return { ...state, isCreatePaymentUrl: true };
    case TYPES.CREATE_PAYMENT_URL_FAILED:
    case TYPES.CREATE_PAYMENT_URL_SUCCESS:
      return { ...state, isCreatePaymentUrl: false };

    case TYPES.GET_PRODUCT_BY_PAYPAL_TRANSACTION:
      return { ...state, productByTxnLoading: true };
    case TYPES.GET_PRODUCT_BY_PAYPAL_TRANSACTION_FAILED:
      return { ...state, productByTxnLoading: false };

    case TYPES.CREATE_KAT_PAYMENT:
      return { ...state, isCreatePaymentUrl: true };
    case TYPES.CREATE_KAT_PAYMENT_FAILED:
    case TYPES.CREATE_KAT_PAYMENT_SUCCESS:
      return { ...state, isCreatePaymentUrl: false };

    case TYPES.SUBMIT_KAT_IPN_FAILED:
    case TYPES.SUBMIT_KAT_IPN_SUCCESS:
      return { ...state };

    case TYPES.CREATE_KYTE_PAYMENT:
      return { ...state, isCreatePaymentUrl: true };
    case TYPES.CREATE_KYTE_PAYMENT_FAILED:
    case TYPES.CREATE_KYTE_PAYMENT_SUCCESS:
      return { ...state, isCreatePaymentUrl: false };

    case TYPES.SUBMIT_KYTE_IPN_FAILED:
    case TYPES.SUBMIT_KYTE_IPN_SUCCESS:
      return { ...state };

    case TYPES.HANDLE_KWALLET_PURCHASE:
      return { ...state, isHanleKWallet: true };
    case TYPES.HANDLE_KWALLET_PURCHASE_FAILED:
      return { ...state, isHanleKWallet: false };
    case TYPES.HANDLE_KWALLET_PURCHASE_SUCCESS:
      return { ...state, isHanleKWallet: false };
    default:
      return state;
  }
};
